"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Toggle = require("../../../components/Toggle");
var _useRequest3 = require("../../../utils/useRequest");
var _endpoints = require("../../../utils/endpoints");
var _SpinGlobal = _interopRequireDefault(require("../../SpinGlobal/SpinGlobal"));
var _toast = require("../../../utils/toast");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TOGGLE_ID = 'coach-only-toggle';
var CoachOnlyToggle = function CoachOnlyToggle(_ref) {
  var clinicianId = _ref.clinicianId;
  var _useRequest = (0, _useRequest3.useRequest)((0, _endpoints.getClinicianCoachOnlyUrl)(clinicianId)),
    status = _useRequest.data,
    statusLoading = _useRequest.loading,
    refreshStatus = _useRequest.refresh;
  var _useRequest2 = (0, _useRequest3.useRequest)(function () {
      return {
        url: (0, _endpoints.getClinicianCoachOnlyUrl)(clinicianId),
        method: 'patch',
        data: {
          coachOnly: !status.coachOnly
        }
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _toast.toast.success({
          title: 'Success!',
          description: 'coach only status updated successfully.'
        });
        refreshStatus();
      }
    }),
    toggleCoachOnlyStatus = _useRequest2.run;
  if (statusLoading) {
    return /*#__PURE__*/_react.default.createElement(_SpinGlobal.default, null);
  }
  var handleToggle = function handleToggle() {
    toggleCoachOnlyStatus();
  };
  return /*#__PURE__*/_react.default.createElement(_Toggle.Toggle, {
    id: TOGGLE_ID,
    checked: status.coachOnly,
    onChange: handleToggle
  });
};
var _default = CoachOnlyToggle;
exports.default = _default;